<template>
  <div class="courses-wrapper">
    <!-- 初始化显示Loading -->
    <template v-if="isInitLoading&&!noData">
      <CourseSkeleton />
    </template>
    <!-- 页面异常状态 -->
    <template v-if="(!isInitLoading&&noData)||!Object.keys(course).length">
      <Exception
        :tip-text="$t('page.common.noResultsFound')" placeholder-class-name="no-avalible-data-img"
        class-name="button-outline"
      />
    </template>
    <template v-else-if="!isInitLoading&&!noData">
      <AggregationalHeader :lowest-price="lowestPrice" :course="course" :show-per-lowest-price="showPerLowestPrice" :open-video="handleOpenVideo" />
      <div v-for="(item,index) in moduleContents" :key="index">
        <div>
          <Introduce v-if="item.type===8" :data="getContent(item)" />
          <TeacherIntro v-if="item.type===10" ref="teacherIntro" :data="getContent(item)" />
          <SelectLevel v-if="item.type===9" :data="getContent(item)" />
          <UkfilterGroup v-if="item.type===11&&item.goodsList" ref="filterDom" :date-list="getContent(item).goodsOverview.filter.dayOfWeek" :time-list="getContent(item).goodsOverview.filter.timePeriod"
                         :level-list="getContent(item).goodsOverview.filter.levelDegree" :goods-list="item.goodsList" :title="getContent(item).title"
                         :grades-list="getContent(item).goodsOverview.filter.gradeList" :filters-list="getContent(item).classCheckedList" :is-filter="getContent(item).classCheck"
                         @change="(...args) => changeHandle(...args,item)"
          />
          <NewGetNotified
            v-if="item.type===24"
            :title="getContent(item).componentData.title"
            :intro="getContent(item).componentData.intro"
            :clue="getContent(item).componentData.clue"
            :auto-tag-id-list="getContent(item).componentData.autoTagIdList"
            :host="getContent(item).componentData.host"
            :secret="getContent(item).componentData.secret"
            :type="type"
            :component-title="getContent(item).componentTitle"
            :module-id="item.id"
            :data-list="getContent(item).componentData.dataList"
            class="get-notified"
          />
        </div>
      </div>
      <!-- <UserInfo v-if="course&&course.selected" /> -->
    </template>
    <no-ssr>
      <VideoPopup ref="videoPopup" />
    </no-ssr>
  </div>
</template>
<script>
import bus from 'common/bus';
import { oneApi } from 'config/api'
import { elementOfArray } from 'common/utils';
// import { createScript } from '../../../../libs/token';
// import gRecaptcha from '@thinkacademy/vitas-utils/gRecaptcha';
import AggregationalHeader from 'components/courses/AggregationalHeader'
import Introduce from 'components/courses/Introduce'
import TeacherIntro from 'components/courses/TeacherIntro'
import SelectLevel from 'components/courses/SelectLevel'
import UkfilterGroup from 'components/courses/UkfilterGroup'
// import UserInfo from 'components/courses/UserInfo'
import Exception from 'components/common/Exception';
import CourseSkeleton from 'components/courses/newCourseSkeleton'
import VideoPopup from 'components/common/VideoPopup/index'
import NewGetNotified from '@/components/global/DynamicComponents/GetNotified-2/web'
// 节流函数
const throttle = require('lodash/throttle');

export default {
  components: {
    AggregationalHeader, UkfilterGroup, SelectLevel, TeacherIntro, Introduce, CourseSkeleton, Exception, VideoPopup, NewGetNotified,
    //   UkSystem, , ,
  },
  async asyncData({ params, $axios }) {
    // 客户端渲染不走服务端渲染逻辑
    if (process.client) {
      return {
        ssr: false,
      }
    }
    const noData = false
    const noTermData = false
    const res = await $axios.post(oneApi.queryMallPage, {
      pageId: params.pageId,
    }, { rewritePostBody: true });
    if (Number(res.code) !== 0) {
      return {
        ssr: false,
      }
    }
    // 通过年级获取的数据
    const resData = res.data || {}
    const course = resData.content ? JSON.parse(resData.content) : {}
    const { moduleContents } = resData;
    let showPerLowestPrice = false
    let isFilter = false
    let lowestPrice = ''
    let dateList = []
    let timeList = []
    let levelList = []
    let gradesList = []
    let filtersList = []
    const courseDateStart = ''
    const courseDateEnd = ''
    let lowestPriceAry = []
    if (resData && resData.moduleContents && moduleContents.filter((item) => item.type === 11).length) {
      const classList = JSON.parse(resData.moduleContents.filter((item) => item.type === 11)[0].content)
      lowestPriceAry = []
      moduleContents.filter((item) => item.type === 11).forEach(async (item0) => {
        if (classList.goodsOverview.overview.perLowestPrice) {
          lowestPriceAry.push(JSON.parse(item0.content).goodsOverview.overview.perLowestPrice)
        } else {
          lowestPriceAry.push(JSON.parse(item0.content).goodsOverview.overview.lowestPrice)
        }
      })
      if (classList.goodsOverview) {
        showPerLowestPrice = classList.goodsOverview.overview.perLowestPrice !== undefined
        lowestPrice = lowestPriceAry.sort((a, b) => b - a)[lowestPriceAry.length - 1]
        const filterObj = classList.goodsOverview.filter || {}
        dateList = filterObj.dayOfWeek || []
        timeList = filterObj.timePeriod || []
        levelList = filterObj.levelDegree || []
        gradesList = filterObj.gradesList || []
        filtersList = classList.classCheckedList || []
        isFilter = classList.classCheck
      }
    }

    return {
      ssr: true,
      course,
      moduleContents,
      dateList,
      timeList,
      levelList,
      gradesList,
      filtersList,
      isFilter,
      courseDateStart,
      courseDateEnd,
      showPerLowestPrice,
      lowestPrice,
      noData,
      noTermData,
    }
  },
  data() {
    return {
      courseIntro: {},
      teacherInfo: {},
      testDetail: {},
      year: 0,
      termList: [],
      dateList: [],
      timeList: [],
      levelList: [],
      gradesList: [],
      filtersList: [],
      isFilter: false,
      courseDateStart: '',
      courseDateEnd: '',
      showPerLowestPrice: false,
      lowestPrice: '',
      goodsList: [],
      course: {},
      currentData: {
        courseIntro: {},
        courseSystem: {},
        teacherInfo: {},
        quizInfo: {},
      },
      defaultTermObj: {},
      defaultDay: '',
      defaultTime: '',
      defaultLevelId: '',
      defaultGradeId: '',
      noTermData: false,
      noData: false,
      isInitLoading: true,
      moduleContents: {},
      type: 'MODULE_OLD',
    }
  },
  computed: {
    pageTitle() {
      return this.course.pageTitle || ''
    },
  },
  created() {
    if (process.client) {
      this.Sensors.keepTime('grade_page_close')
      this.Sensors.track('grade_page_pv', {
        grade_name: this.$route.query.name,
        page_url: window.location.href,
      })
    }
  },
  async mounted() {
    // const { verifyKey } = process.env;
    // await gRecaptcha.createScript.call(this, verifyKey)
    this.isInitLoading = true;
    await this.initPage()
    this.isInitLoading = false;
    // 请求年级列表
    await this.$store.dispatch('courses/queryGradeList', { $axios: this.$axios })
    this.$nextTick(() => {
      this.addScrollEvent();
    })
    bus.$on('coursesDetail.refresh', () => {
      this.initPage();
    });
  },
  beforeDestroy() {
    this.removeScrollEvent();
    this.Sensors.track('grade_page_close', {
      grade_name: this.course.name,
      page_url: window.location.href,
    })
  },
  destroyed() {
    bus.$off('coursesDetail.refresh')
  },
  methods: {
    getContent(val) {
      return JSON.parse(val.content)
    },
    async initPage() {
      const res = await this.$axios.post(oneApi.queryMallPage, {
        pageId: this.$route.params.pageId,
      }, { rewritePostBody: true });
      if (Number(res.code) !== 0) {
        this.noData = true
      }
      const resData = res.data || {}
      this.course = resData.content ? JSON.parse(resData.content) : {}
      this.moduleContents = resData.moduleContents;
      let classList = []
      let lowestPriceAry = []
      if (resData && resData.moduleContents && this.moduleContents.filter((item) => item.type === 11).length) {
        classList = JSON.parse(resData.moduleContents.filter((item) => item.type === 11)[0].content)
        lowestPriceAry = []
        this.moduleContents.filter((item) => item.type === 11).forEach(async (item0) => {
          if (classList.goodsOverview.overview.perLowestPrice !== undefined) {
            lowestPriceAry.push(JSON.parse(item0.content).goodsOverview.overview.perLowestPrice)
          } else {
            lowestPriceAry.push(JSON.parse(item0.content).goodsOverview.overview.lowestPrice)
          }
          // 获取筛选列表数据
          const filterData = await this.$axios.post(oneApi.queryGoodsByModule, {
            courseIdList: JSON.parse(item0.content).courseIds,
            moduleType: 11,
            specValues: [],
          }, { rewritePostBody: true });
          const datas = filterData.data || {}
          this.$set(item0, 'goodsList', datas.goodsList)
          const filterObj = JSON.parse(item0.content).goodsOverview.filter || {}
          this.$set(item0, 'dateList', filterObj.dayOfWeek || [])
          this.$set(item0, 'timeList', filterObj.timePeriod || [])
          this.$set(item0, 'levelList', filterObj.levelDegree || [])
          this.$set(item0, 'gradesList', filterObj.gradesList || [])
          this.$set(item0, 'filtersList', JSON.parse(item0.content).classCheckedList || [])
          this.$set(item0, 'isFilter', JSON.parse(item0.content).classCheck)
        })
        this.classList = classList
        this.showPerLowestPrice = classList.goodsOverview.overview.perLowestPrice !== undefined
        this.lowestPrice = lowestPriceAry.sort((a, b) => b - a)[lowestPriceAry.length - 1]
      }
      // 通过年级获取的数据
      const resOverview = resData.overview || {}
      this.courseDateStart = resOverview.courseDateStart;
      this.courseDateEnd = resOverview.courseDateEnd;
    },
    exceptionRetryHandler() {
      this.$router.replace('/home')
    },

    // filter改变事件
    changeHandle(obj, item) {
      const value = obj.value === 'All' ? '' : obj.value
      switch (obj.type) {
        case 'day':
          this.$set(item, 'defaultDay', value)
          break;
        case 'time':
          this.$set(item, 'defaultTime', value)
          break;
        case 'level':
          this.$set(item, 'defaultLevelId', value)
          break;
        case 'grade':
          this.$set(item, 'defaultGradeId', value)
          break;
        default:
          break;
      }
      this.getCourseInfo(item)
    },
    async getCourseInfo(item) {
      // 默认有年级参数
      const specValues = [
      ]
      // 如果有level
      if (item.defaultLevelId) {
        specValues.push({
          specId: 4,
          specValue: item.defaultLevelId,
        })
      }
      if (item.defaultGradeId) {
        specValues.push({
          specId: 2,
          specValue: item.defaultGradeId,
        })
      }
      const data = {
        specValues,
        courseIdList: JSON.parse(item.content).courseIds,
        moduleType: 11,
        dayOfWeek: item.defaultDay,
        lessonTimeBegin: item.defaultTime ? item.defaultTime.split('-')[0] : '',
        lessonTimeEnd: item.defaultTime ? item.defaultTime.split('-')[1] : '',
      }
      const classInfo = await this.$axios.post(oneApi.queryGoodsByModule, data, { rewritePostBody: true });
      const infoData = classInfo.data || {}
      const contentItem = elementOfArray('id', item.id, this.moduleContents);
      this.$set(contentItem, 'goodsList', infoData.goodsList)
    },
    // 添加页面滚动事件
    addScrollEvent() {
      window.addEventListener('scroll', this.watchScroll, false);
    },
    // 移除页面滚动事件
    removeScrollEvent() {
      window.removeEventListener('scroll', this.watchScroll, false);
    },
    // 监听页面滚动条事件
    watchScroll: throttle(function watchPageScroll() {
      if (this.$refs.teacherIntro) this.$refs.teacherIntro[0].pageScrollHandler()
      if (this.$refs.filterDom) this.$refs.filterDom[0].pageScrollHandler();
    }),
    handleOpenVideo(videoUrl) {
      this.$refs.videoPopup.handleOpen(videoUrl)
    },
  },
  head() {
    if (this.$store.state.website.page.isDefault === 0) return {}
    return {
      title: this.pageTitle,
    }
  },
}
</script>
<style lang="scss" scoped>
.courses-wrapper {
  min-height: calc(100vh - 80px);
  background: #f4f6fa;
  position: relative;

  .error-container {
    padding: 50px 0;
  }
}

.get-notified {
  background-color: #fff;
  width: 100%;
  margin: 0 auto 50px;
}

</style>

<style>
.grecaptcha-badge { visibility: hidden; }
</style>
